import useFileSaver from '@hooks/useFileSaver';
import useRequest, { IDataRequest } from '@hooks/useRequest';
import { IContratoCliente } from '@model/ContratoCliente';
import { TDate } from '@utils/TypeHelpers';
import React from 'react';

export interface IRelatorioCancelamentoFilter {
    whatsappEnvio?: string
    dataCancelamentoDe?: TDate
    dataCancelamentoAte?: TDate
}

const controller = '/Relatorio/Cancelamento';

export function useRelatorioCancelamentoService () {
    const _request = useRequest();
    const fileSaver = useFileSaver();

    const listar = React.useCallback((request: IDataRequest<IRelatorioCancelamentoFilter>) => {
        return _request.getData<IContratoCliente[]>(`${controller}/Listar`, request);
    }, [_request]);

    const exportar = React.useCallback((request: IDataRequest<IRelatorioCancelamentoFilter>) => {
        return _request.download(`${controller}/Exportar`, {
            params: request
        })
            .then(response => { 
                fileSaver.save(response, `Cancelamento.csv`);
            });
    }, [_request, fileSaver]);

    return React.useMemo(() => ({
        listar, exportar
    }), [listar, exportar]);
}